export default __webpack_public_path__ + "static/clayton-a916cefe47584fd33ca5814800e568f3.jpg";